import ReactMarkdown from "react-markdown";
import RehypeRaw from "rehype-raw";

import { remarkVimeo } from "../helpers/markdown";
import CodeBlock from "./CodeBlock";

import S from "../_styles.module.scss";

interface Task {
  content?: { markdown: string };
}

interface TasksProps {
  tasks: Task[];
}

const Tasks = ({ tasks }: TasksProps) => {
  return (
    <ol className={S.taskList}>
      {tasks.map((task, index) => (
        <li key={index} className={S.taskStep}>
          <ReactMarkdown
            remarkPlugins={[remarkVimeo]}
            rehypePlugins={[RehypeRaw]}
            components={{
              h2: h2 => <h2 className="atlas-h4">{h2.children}</h2>,
              pre: pre => {
                return <CodeBlock node={pre.node}>{pre.children}</CodeBlock>;
              },
              code: code => <code className="atlas-code">{code.children}</code>,
              blockquote: ({ children }) => (
                <blockquote className="atlas-blockquote">{children}</blockquote>
              ),
            }}
          >
            {task.content?.markdown}
          </ReactMarkdown>
        </li>
      ))}
    </ol>
  );
};

export default Tasks;
